import { __decorate, __metadata } from "tslib";
import { PrivateAPINamespace } from '../PrivateAPINamespace';
import { Addon, ApiConfig } from '../../limitPrivateAPI';
export class ApplicationManagerNamespace extends PrivateAPINamespace {
    setApplication(app) {
        this.ps.apps.setApplication(app);
    }
    async getPublicApplicationAPI(appDefinitionId) {
        return this.ps.apps.getPublicAPIWhenAppIsReady(appDefinitionId);
    }
}
ApplicationManagerNamespace.namespace = 'applicationManager';
__decorate([
    ApiConfig(Addon),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ApplicationManagerNamespace.prototype, "setApplication", null);
__decorate([
    ApiConfig(Addon),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Promise)
], ApplicationManagerNamespace.prototype, "getPublicApplicationAPI", null);
//# sourceMappingURL=ApplicationManagerNamespace.js.map